import { render, staticRenderFns } from "./eventListComponent.vue?vue&type=template&id=e8e53c5e&"
import script from "./eventListComponent.vue?vue&type=script&lang=ts&"
export * from "./eventListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports